import { useQuery } from '@tanstack/react-query'
import { defaultSiteContent, mergeSiteContent } from '@/lib/siteContent'
import type { SiteContent } from '@/lib/siteContent'
import { isSupabaseConfigured, supabase } from '@/lib/supabase'

type SiteContentRow = {
  content: unknown
}

export const siteContentQueryKey = ['site-content']

export const useSiteContent = () => {
  const query = useQuery<SiteContent>({
    queryKey: siteContentQueryKey,
    enabled: isSupabaseConfigured,
    queryFn: async () => {
      if (!supabase) {
        return defaultSiteContent
      }

      const { data, error } = await supabase
        .from('site_content')
        .select('content')
        .eq('key', 'site')
        .maybeSingle<SiteContentRow>()

      if (error) {
        throw error
      }

      return mergeSiteContent(data?.content)
    },
  })

  return {
    ...query,
    content: query.data ?? defaultSiteContent,
    isSupabaseConfigured,
  }
}
